import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OfflineBarComponent } from './offline-bar.component';
import { TranslateModule } from '../../../core/translate/translate.module';
import { MatButtonModule } from '@angular/material/button';
import { ButtonModule } from '../../atoms/button/button.module';

@NgModule({
  declarations: [
    OfflineBarComponent
  ],
	imports: [
		CommonModule,
		TranslateModule,
		MatButtonModule,
		ButtonModule
	],
  exports: [
    OfflineBarComponent
  ]
})
export class OfflineBarModule { }
